export default class Search
{
	constructor()
	{
		this.searchPanel = document.querySelector(".jsSearchPanel");
		this.searchToggle = document.querySelector(".jsSearchToggle");
		this.searchInput = document.querySelector(".jsSearchInput");
		this.searchSubmit = document.querySelector(".jsSearchSubmit");
		this.init();
	}

	toggle(i)
	{
		this.searchPanel.classList.contains("-opened")
			? this.collapse()
			: this.expand();
	}

	expand()
	{
		this.enable();
		this.searchPanel.classList.add("-opened");
		this.searchInput.focus();
	}

	enable()
	{
		this.searchInput.disabled = false;
		this.searchSubmit.disabled = false;
	}

	disable()
	{
		this.searchInput.disabled = true;
		this.searchSubmit.disabled = true;
	}

	collapse()
	{
		this.searchInput.blur();
		this.searchPanel.classList.remove("-opened");
		this.disable();
	}

	init()
	{
		if (this.searchToggle != null)
		{
			this.searchToggle.addEventListener("click", () => {
				this.toggle();
			});
			window.addEventListener('resize', () =>
			{
				let mql = window.matchMedia('(min-width: 768px)');
				mql.matches ? this.disable() : this.enable();
			});
		}
	}
}
